import { useNavigate } from 'react-router-dom'

export default function ExerciseCard({ exercise, onDelete }) {
  const navigate = useNavigate()

  return (
    <div className="card" style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
      {exercise.media_url ? (
        <img
          src={exercise.media_url}
          alt={exercise.title}
          style={{ width: 72, height: 72, objectFit: 'cover', borderRadius: 10, flexShrink: 0 }}
        />
      ) : (
        <div style={{
          width: 72, height: 72, borderRadius: 10, flexShrink: 0,
          background: 'var(--brand-light)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 28
        }}>💪</div>
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        <p style={{ fontWeight: 600, color: 'var(--text-primary)', marginBottom: 4, fontSize: 15 }}>
          {exercise.title}
        </p>
        {exercise.description && (
          <p style={{ fontSize: 13, marginBottom: 8, lineHeight: 1.5 }}>{exercise.description}</p>
        )}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {exercise.sets && <span className="badge">{exercise.sets} sets</span>}
          {exercise.reps && <span className="badge">{exercise.reps} reps</span>}
          {exercise.duration_seconds && <span className="badge">{exercise.duration_seconds}s</span>}
        </div>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0 }}>
        <button
          className="secondary"
          onClick={() => navigate('/clinician/exercises/' + exercise.id + '/edit')}
          style={{ fontSize: 12, padding: '6px 12px' }}
        >
          Edit
        </button>
        {onDelete && (
          <button className="danger" onClick={() => onDelete(exercise.id)} style={{ fontSize: 12 }}>
            Delete
          </button>
        )}
      </div>
    </div>
  )
}
